module.exports = {
  "defaultLanguage": "fr-FR",
  "languages": [
    {
      "code": "fr-FR",
      "name": "Français",
      "icon": null
    },
    {
      "code": "en-US",
      "name": "English",
      "icon": null
    }
  ]
}